var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.state.spinner.addSpinner)?_c('div',[_c('Spinner')],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }